import { Box, Grid, Stack, Typography } from '@mui/material';
import dayjs from 'dayjs';
import * as React from 'react';
import * as Redux from 'react-redux';
import { dateformat, diasDeSemanaUtil } from '../../../helpers';
import { diasContinuoClases } from '../boletines/BoletinesHelper';

const CuadroAsistenciasComponent = () => {
  const asistenciasStore = Redux.useSelector((state) => state.asistencias);

  const [meses, setMeses] = React.useState([]);
  const [dias, setDias] = React.useState([]);

  function getMonthsInRange(startDate, endDate) {
    const months = [];
    let currentDate = new dayjs(startDate);
    let fechaFinal = new dayjs(endDate);

    while (
      currentDate.isBefore(fechaFinal) ||
      currentDate.isSame(endDate, 'month')
    ) {
      const month = currentDate.month();
      if (!months.includes(month)) {
        months.push(month);
      }
      currentDate = currentDate.add(1, 'month');
    }

    return months;
  }

  React.useEffect(() => {
    const fetchData = () => {
      const fechaInicio = asistenciasStore.planEvaluacion.fechaBloque.desde;
      const fechaFinal = asistenciasStore.planEvaluacion.fechaBloque.hasta;
      const monthsInRange = getMonthsInRange(fechaInicio, fechaFinal);
      setMeses(monthsInRange);

      let diaHor = {};

      asistenciasStore.activo.horarios.forEach((el) => {
        const dd = diasDeSemanaUtil.find((ds) => ds.dia === el.dia);
        const tt = diasContinuoClases(dd.id, fechaInicio, fechaFinal);
        if (!diaHor[el.dia]) {
          diaHor[el.dia] = tt;
        }
        console.log(`tt ${el.dia}`, diaHor);
      });

      setDias(diaHor);
    };

    fetchData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const getAsistenciaHandler = (dia, horario) => {
    const existe = horario.asistencias.some((a) => {
      const hIni = dateformat(`${dateformat(dia, {})} ${horario.horaInicio}`, {
        format: 'YYYY-MM-DD HH:mm',
      });
      const hFin = dateformat(`${dateformat(dia, {})} ${horario.horaFinal}`, {
        format: 'YYYY-MM-DD HH:mm',
      });
      const fasi = dateformat(a.fechaHora, { format: 'YYYY-MM-DD HH:mm' });
      return fasi >= hIni && fasi <= hFin;
    });

    return existe;
  };

  return (
    <Grid container spacing={0}>
      <Grid item md={12}>
        <Stack direction="row" spacing={1}>
          {meses.map((el) => {
            return (
              <Box sx={{ width: '100%', backgroundColor: '#f1f1f1' }}>
                <Typography sx={{ fontWeight: 'bold', textAlign: 'center' }}>
                  {dateformat(`${dayjs().year()}-${el + 1}-10`, {
                    format: 'MMMM',
                  }).toUpperCase()}
                </Typography>
                <Stack direction="row" spacing={0}>
                  {asistenciasStore.activo.horarios.map((hor) => {
                    return (
                      <Box sx={{ width: '100%', backgroundColor: '#d1d1d1' }}>
                        <Typography sx={{ textAlign: 'center', p: 0.2 }}>
                          {hor.dia}
                        </Typography>
                        <Typography sx={{ textAlign: 'center', p: 0.2 }}>
                          {hor.horaInicio} - {hor.horaFinal}
                        </Typography>
                        {dias[hor.dia].map((dia) => {
                          if (dayjs(dia).month() === el) {
                            return (
                              <Box
                                sx={{
                                  display: 'flex',
                                  height: '60px',
                                  p: 1,
                                  m: 1,
                                  backgroundColor: getAsistenciaHandler(
                                    dia,
                                    hor,
                                  )
                                    ? 'green'
                                    : 'gray',
                                }}
                              >
                                <Typography
                                  sx={{
                                    fontWeight: 'bold',
                                    fontSize: '16pt',
                                    color: getAsistenciaHandler(dia, hor)
                                      ? 'white'
                                      : 'black',
                                  }}
                                >
                                  {dateformat(dia, { format: 'DD' })}
                                </Typography>
                              </Box>
                            );
                          }
                          return null;
                        })}
                      </Box>
                    );
                  })}
                </Stack>
              </Box>
            );
          })}
        </Stack>
      </Grid>
    </Grid>
  );
};

export default CuadroAsistenciasComponent;
